import _classCallCheck from "/neworiental/jenkins/workspace/seal-remixed-troy-student-web/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/neworiental/jenkins/workspace/seal-remixed-troy-student-web/node_modules/@babel/runtime/helpers/esm/createClass";
import "core-js/modules/es.json.stringify.js";

/**
 * @Author       : lvquanqiang@xdf.cn
 * @Date         : 2021-10-28 15:51:30
 * @LastEditors  :
 * @LastEditTime :
 * @Description  : 记录学段、学科、自学宝、大纲的展开收起/选中状态
 */
// 注意：所有的edu取值全部来自localStorage中userInfo.edu
//  current: {
//    3: {
//      subjectId: 1,
//      boxMap: { 1: 10101, 2: 30290 }
//    },
//    4: { subjectId: 2, }
//  },
//  outline: {
//    3: {
//      1: {
//         1101: {selectNode,state,openNodes}
//      }
//    },
//    4: {}
//  }
var OutlineCache = /*#__PURE__*/function () {
  function OutlineCache() {
    _classCallCheck(this, OutlineCache);

    var cache = this.getOutlineCache();
    this.outline_cache = cache || {
      current: {},
      // 缓存当前选择的学段学科自学宝
      outline: {} // 缓存所有自学宝大纲的筛选/展开收起/选中的节点

    };
  }

  _createClass(OutlineCache, [{
    key: "setOutlineCache",
    value: function setOutlineCache() {
      localStorage.setItem('outline_cache', JSON.stringify(this.outline_cache));
    }
  }, {
    key: "getOutlineCache",
    value: function getOutlineCache() {
      var cache = localStorage.getItem('outline_cache');

      if (cache) {
        return JSON.parse(cache);
      }

      return null;
    } // 切换学科

  }, {
    key: "switchSubject",
    value: function switchSubject() {
      var edu = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 3;
      var subjectId = arguments.length > 1 ? arguments[1] : undefined;
      var isUpdateCache = arguments.length > 2 ? arguments[2] : undefined;

      if (!this.outline_cache.current[edu]) {
        this.outline_cache.current[edu] = {
          boxMap: {}
        };
      }

      this.outline_cache.current[edu].subjectId = subjectId;
      isUpdateCache && this.setOutlineCache();
    } // 切换自学宝

  }, {
    key: "switchBox",
    value: function switchBox() {
      var edu = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 3;
      var subjectId = arguments.length > 1 ? arguments[1] : undefined;
      var boxId = arguments.length > 2 ? arguments[2] : undefined;

      if (!this.outline_cache.current[edu]) {
        this.outline_cache.current[edu] = {
          subjectId: subjectId,
          boxMap: {}
        };
      }

      this.outline_cache.current[edu].boxMap[subjectId] = boxId;
      this.setOutlineCache();
    } // 数据补全

  }, {
    key: "completeData",
    value: function completeData() {
      var edu = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 3;
      var subjectId = arguments.length > 1 ? arguments[1] : undefined;
      var boxId = arguments.length > 2 ? arguments[2] : undefined;

      if (!this.outline_cache.outline[edu]) {
        this.outline_cache.outline[edu] = {};
      }

      if (!this.outline_cache.outline[edu][subjectId]) {
        this.outline_cache.outline[edu][subjectId] = {};
      }

      if (!this.outline_cache.outline[edu][subjectId][boxId]) {
        this.outline_cache.outline[edu][subjectId][boxId] = {};
      }
    } // 更新选择的节点

  }, {
    key: "changeOutline",
    value: function changeOutline() {
      var edu = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 3;
      var subjectId = arguments.length > 1 ? arguments[1] : undefined;
      var boxId = arguments.length > 2 ? arguments[2] : undefined;
      var selectNode = arguments.length > 3 ? arguments[3] : undefined;
      this.completeData(edu, subjectId, boxId);
      this.outline_cache.outline[edu][subjectId][boxId].selectNode = selectNode;
      this.setOutlineCache();
    } // 更新选择的状态

  }, {
    key: "changeState",
    value: function changeState() {
      var edu = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 3;
      var subjectId = arguments.length > 1 ? arguments[1] : undefined;
      var boxId = arguments.length > 2 ? arguments[2] : undefined;
      var state = arguments.length > 3 ? arguments[3] : undefined;
      this.completeData(edu, subjectId, boxId);
      this.outline_cache.outline[edu][subjectId][boxId].state = state;
      this.setOutlineCache();
    } // 更新打开的所有节点

  }, {
    key: "changeOpenNodes",
    value: function changeOpenNodes() {
      var edu = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 3;
      var subjectId = arguments.length > 1 ? arguments[1] : undefined;
      var boxId = arguments.length > 2 ? arguments[2] : undefined;
      var openNodes = arguments.length > 3 ? arguments[3] : undefined;
      this.completeData(edu, subjectId, boxId);
      this.outline_cache.outline[edu][subjectId][boxId].openNodes = openNodes;
      this.setOutlineCache();
    } // 自学宝被解绑后，删除缓存

  }, {
    key: "removeBox",
    value: function removeBox() {
      var edu = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 3;
      var subjectId = arguments.length > 1 ? arguments[1] : undefined;
      var boxId = arguments.length > 2 ? arguments[2] : undefined;
      this.completeData(edu, subjectId, boxId);
      delete this.outline_cache.outline[edu][subjectId][boxId];
    } // 获取当前的科目

  }, {
    key: "getCurrentSubject",
    value: function getCurrentSubject() {
      var edu = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 3;

      if (this.outline_cache.current[edu]) {
        return this.outline_cache.current[edu].subjectId;
      }

      return null;
    } // 获取当前的自学宝

  }, {
    key: "getCurrentBox",
    value: function getCurrentBox() {
      var edu = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 3;
      var subjectId = arguments.length > 1 ? arguments[1] : undefined;

      if (this.outline_cache.current[edu]) {
        return this.outline_cache.current[edu].boxMap[subjectId];
      }

      return null;
    } // 检查数据，没有学段、学科、自学宝，说明没存过

  }, {
    key: "checkData",
    value: function checkData() {
      var edu = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 3;
      var subjectId = arguments.length > 1 ? arguments[1] : undefined;
      var boxId = arguments.length > 2 ? arguments[2] : undefined;
      var eduData = this.outline_cache.outline[edu];
      return eduData && eduData[subjectId] && eduData[subjectId][boxId];
    } // 获取自学宝所有打开的节点

  }, {
    key: "getOpenNodes",
    value: function getOpenNodes() {
      var edu = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 3;
      var subjectId = arguments.length > 1 ? arguments[1] : undefined;
      var boxId = arguments.length > 2 ? arguments[2] : undefined;

      if (this.checkData(edu, subjectId, boxId)) {
        return this.outline_cache.outline[edu][subjectId][boxId].openNodes;
      }

      return null;
    } // 获取自学宝的状态

  }, {
    key: "getBoxState",
    value: function getBoxState() {
      var edu = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 3;
      var subjectId = arguments.length > 1 ? arguments[1] : undefined;
      var boxId = arguments.length > 2 ? arguments[2] : undefined;

      if (this.checkData(edu, subjectId, boxId)) {
        return this.outline_cache.outline[edu][subjectId][boxId].state;
      }

      return null;
    } // 获取自学宝选中的节点

  }, {
    key: "getSelectNode",
    value: function getSelectNode() {
      var edu = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 3;
      var subjectId = arguments.length > 1 ? arguments[1] : undefined;
      var boxId = arguments.length > 2 ? arguments[2] : undefined;

      if (this.checkData(edu, subjectId, boxId)) {
        return this.outline_cache.outline[edu][subjectId][boxId].selectNode;
      }

      return null;
    } // 更新书本学习进度打开的所有节点

  }, {
    key: "changeProgressOpenNodes",
    value: function changeProgressOpenNodes() {
      var edu = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 3;
      var subjectId = arguments.length > 1 ? arguments[1] : undefined;
      var boxId = arguments.length > 2 ? arguments[2] : undefined;
      var openNodes = arguments.length > 3 ? arguments[3] : undefined;
      this.completeData(edu, subjectId, boxId);
      this.outline_cache.outline[edu][subjectId][boxId].progressOpenNodes = openNodes;
      this.setOutlineCache();
    } // 获取书本学习进度所有打开的节点

  }, {
    key: "getProgressOpenNodes",
    value: function getProgressOpenNodes() {
      var edu = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 3;
      var subjectId = arguments.length > 1 ? arguments[1] : undefined;
      var boxId = arguments.length > 2 ? arguments[2] : undefined;

      if (this.checkData(edu, subjectId, boxId)) {
        return this.outline_cache.outline[edu][subjectId][boxId].progressOpenNodes;
      }

      return null;
    }
  }], [{
    key: "getInstance",
    value: function getInstance() {
      if (!this.instance) {
        this.instance = new OutlineCache();
      }

      return this.instance;
    }
  }, {
    key: "removeOutlineCache",
    value: function removeOutlineCache() {
      var ii = OutlineCache.getInstance();
      ii ? ii.outline_cache = {
        current: {},
        // 缓存当前选择的学段学科自学宝
        outline: {} // 缓存所有自学宝大纲的筛选/展开收起/选中的节点

      } : null;
      this.instance = null;
      localStorage.removeItem('outline_cache');
      localStorage.removeItem('subject');
      localStorage.removeItem('preciousMessage');
      localStorage.removeItem('preciousInformation');
    }
  }]);

  return OutlineCache;
}();

export { OutlineCache as default };